import React from "react";
import { makePath } from "@admin/utils/makePath";
import { FileModel } from "@admin/domain/files/model/FileModel";
import { readableFileSize } from "@admin/utils/formatters";

type Props = {
    preview: FileModel;
};

export default function FilePreview({ preview }: Props) {
    return (
        <div className="mt-5 ms-5">
            <div className="fw-bolder mb-2">Превью файл:</div>
            <div className="d-flex">
                <img className="me-3 img-thumbnail product_list_img" src={makePath(preview.path)} alt="image" />
                <div className="d-flex flex-column justify-content-center">
                    <div>
                        <span className="fw-bolder">Название файла: </span>
                        {preview.name}
                    </div>
                    <div>
                        <span className="fw-bolder">Формат файла: </span>
                        {preview.mime}
                    </div>
                    <div>
                        <span className="fw-bolder">Размер файла: </span>
                        {readableFileSize(preview.metadata.size)}
                    </div>
                </div>
            </div>
        </div>
    );
}
